// @flow strict

import * as React from 'react'
import {
  AccessibilityText,
  TrackEvents,
  BusinessButton,
  URLS,
} from '@mondough/public-web-components'

import { MarkdownContent } from '../MarkdownContent'
import { SectionWrapper, SectionThemes } from '../SectionWrapper'

import styles from './BusinessCTASection.module.scss'
import appStoreLogo from '../../../static/images/appStoreLogo.svg'
import playStoreLogo from '../../../static/images/playStoreLogo.svg'

export type CTAProps = {|
  ctaType: 'appStore' | 'download',
  title: string,
  subtitle?: string,
  reverse: boolean,
|}

const BusinessCTASection = ({
  ctaType,
  title,
  subtitle,
  reverse,
}: CTAProps) => {
  return (
    <SectionWrapper
      className={styles.section}
      contentClassName={styles.container}
      theme={reverse ? SectionThemes.GREY : SectionThemes.LIGHT}
    >
      <div className={styles.columnOne} id="CTASection">
        <h2 className={styles.title}>{title}</h2>
        <MarkdownContent className={styles.markdownContent}>
          {subtitle}
        </MarkdownContent>
      </div>
      <div className={styles.columnTwo}>
        {ctaType === 'appStore' && (
          <div className={styles.appButtons}>
            <TrackEvents
              category="conversion"
              action="download app"
              label="apple"
            >
              <a data-testid="app-store-link" href={URLS.ADJUST_APP_STORE}>
                <AccessibilityText>
                  Download Monzo from the App Store
                </AccessibilityText>
                <img
                  src={appStoreLogo}
                  alt=""
                  className={styles.appStoreLogo}
                />
              </a>
            </TrackEvents>
            <TrackEvents
              category="conversion"
              action="download app"
              label="google"
            >
              <a
                data-testid="play-store-link"
                className={styles.playStoreButton}
                href={URLS.ADJUST_PLAY_STORE}
              >
                <AccessibilityText>
                  Download Monzo from the Google Play Store
                </AccessibilityText>
                <img
                  src={playStoreLogo}
                  alt=""
                  className={styles.appStoreLogo}
                />
              </a>
            </TrackEvents>
          </div>
        )}
        {ctaType === 'download' && (
          <TrackEvents
            category="conversion"
            action="download app"
            label="download"
          >
            <BusinessButton href="https://monzo.com/i/business/sign-up-for-business">
              Download Monzo
            </BusinessButton>
          </TrackEvents>
        )}
      </div>
    </SectionWrapper>
  )
}

export default BusinessCTASection
